import ModeShippingWizard from './modeShippingWizard.js'

import EndPoint from './endPoint.js'
import MapsLoader from '../maps/maps.js'
import Loader from '../loader/loader.js'
import TownList from '../droplist/townlist.js'
import MessageBoxManager from '../messageBox/messageBoxManager.js'
import CssUtils from '../utils/css.js'
import Config from '../config.js'
import StringUtils from '../utils/string.js'

export default class RelayShippingWizard extends ModeShippingWizard {
  constructor ($container, options) {
    super($container, options)

    this.settings = $.extend({}, {
      defaultZoom: 15,
      apiKey: Config.mapsApiKey,
      defaultFreeRelaysFilter: true,
      expectsFreeRelays: true
    }, this.settings)

    this.currentAddress = { text: '', address: null, used: null }
    this.map = null
    this.$map = null
    this.$mapContainer = null
    this.$suggestedList = null
    this.$switchUILink = null
    this.markers = []
    this.infoWindows = new Map()
    this.googleMapsAPI = null
    this.subjectMarker = null
    this.filterFreeRelays = this.settings.defaultFreeRelaysFilter && this.settings.expectsFreeRelays
    this.typeFilter = null
    this.messageBoxManager = new MessageBoxManager($container)
    this.mapSwitcherLabels = {
      showMap: '<i class="fa fa-map-marker" aria-hidden="true"></i> Voir la carte',
      showList: '<i class="fa fa-list" aria-hidden="true"></i> Voir la liste'
    }
  }

  initIcons () {
    let buildPinImage = options => {
      return $.extend({}, {
        path: 'm 0,0 c -2,-20 -10,-22 -10,-30 0,-5.522851 4.4771526,-9.999996 10,-9.999996 5.5228474,0 10,4.477145 10,9.999996 0,8 -8,10 -10,30 z m -2,-30 c 0,2.666666 4,2.666666 4,0 0,-2.666666 -4,-2.666666 -4,0',
        fillColor: '#f00',
        fillOpacity: 1,
        strokeColor: '#000',
        strokeWeight: 1,
        scale: 1
      }, options)
    }

    this.icons = {
      'relais_colis': buildPinImage({
        fillColor: CssUtils.getCssProperty('.mapPin.relais_colis', 'fill'),
        strokeColor: CssUtils.getCssProperty('.mapPin.relais_colis', 'stroke')
      }),

      'mondial_relay': buildPinImage({
        fillColor: CssUtils.getCssProperty('.mapPin.mondial_relay', 'fill'),
        strokeColor: CssUtils.getCssProperty('.mapPin.mondial_relay', 'stroke')
      }),

      'chronorelais': buildPinImage({
        fillColor: CssUtils.getCssProperty('.mapPin.chronorelais', 'fill'),
        strokeColor: CssUtils.getCssProperty('.mapPin.chronorelais', 'stroke')
      })
    }
  }

  simplifySearchedAddress () {
    if (this.currentAddress.used === null) {
      this.currentAddress.used = [
        this.currentAddress.address.street,
        this.currentAddress.address.cp,
        this.currentAddress.address.town,
        this.currentAddress.address.countryFull
      ]
    } else {
      this.currentAddress.used.splice(0, 1)
    }
    this.currentAddress.text = this.currentAddress.used.join(' ')
  }

  updateAddress (address) {
    // console.log('updateAddress')

    this.currentAddress = {
      address: address,
      used: null,
      text: ''
    }

    if (this.currentAddress.address) {
      this.simplifySearchedAddress()
    }
  }

  createMap () {
    this.$mapContainer = $('<div/>').appendTo(this.$container)
    this.$map = $('<div/>', {
      class: 'map'
    }).appendTo(this.$mapContainer)

    return new Promise((resolve, reject) => {
      let mapsLoad = new MapsLoader()

      mapsLoad.then(maps => {
        var paris = { lat: 48.8651, lng: 2.34315 }
        this.googleMapsAPI = maps
        this.map = new this.googleMapsAPI.Map(this.$map.get(0), {
          center: paris,
          zoom: this.settings.defaultZoom,
          navigationControl: true,
          scaleControl: true,
          mapTypeId: this.googleMapsAPI.MapTypeId.ROADMAP
        })

        this.handleMapClick()

        if (this.icons == undefined) {
          this.initIcons()
        }

        resolve(this.map)
      })
        .catch(reject)
    })
  }

  handleMapClick () {
    this.googleMapsAPI.event.addListener(this.map, 'dblclick', event => {
      if (this.settings.forceOffer == undefined) {
        let geocoder = new this.googleMapsAPI.Geocoder()
        geocoder.geocode({
          'latLng': event.latLng
        }, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            let relevantResults = results
              .map(result => ({
                locality: result.address_components
                  .filter(component => component.types.indexOf('locality') > -1)
                  .map(component => component.long_name),
                cp: result.address_components
                  .filter(component => component.types.indexOf('postal_code') > -1)
                  .map(component => component.long_name)
              }))
              .filter(({ locality: localities, cp: cps }) => localities.length && cps.length)
              .map(({ locality: [locality, ...localities], cp: [cp, ...cps] }) => ({ locality: locality, cp: cp }))

            if (relevantResults.length) {
              this.searchAlternativeEndPoints(
                relevantResults[0].cp,
                relevantResults[0].locality
              )
            }
          }
        })
      }
    })
  }

  updateSubject (location) {
    if (location && location instanceof Object) {
      this.subjectMarker = this.addMarker({
        position: location
      })
      this.fitMap()
    } else {
      let geocoder = new this.googleMapsAPI.Geocoder()

      var callback = (results, status) => {
        if (status == this.googleMapsAPI.GeocoderStatus.OK) {
          this.subjectMarker = this.addMarker({
            position: results[0].geometry.location,
            title: location !== undefined
              ? location
              : this.currentAddress.address.name,
            content: location !== undefined
              ? location
              : this.currentAddress.text
          })
          this.fitMap()
        } else if (location === undefined) {
          this.simplifySearchedAddress()
          if (this.currentAddress.text != '') {
            geocoder.geocode({
              address: this.currentAddress.text
            }, callback)
          }
        }
      }

      geocoder.geocode({
        address: location !== undefined
          ? location
          : this.currentAddress.text
      }, callback)
    }
  }

  addMarker (options) {
    let settings = $.extend({}, {
      map: this.map,
      content: null
    }, options)

    let marker = new this.googleMapsAPI.Marker(settings)

    if (settings.content != null) {
      let infowindow = new this.googleMapsAPI.InfoWindow({
        content: settings.content,
        size: new this.googleMapsAPI.Size(60, 60)
      })

      this.infoWindows.set(marker, infowindow)
    }

    this.markers.push(marker)
    return marker
  }

  clearMarkers () {
    for (let marker of this.markers) {
      marker.setMap(null)
    }

    this.markers = []
    for (let [marker, infoWindow] of this.infoWindows) {
      infoWindow.close()
    }

    this.infoWindows = new Map()
  }

  retrieveEndPoints (configuration) {
    // console.log('retrieveEndPoints')
    if (this.settings.forceOffer === undefined) {
      return new Promise((resolve, reject) => {
        $.post('core/ajax/ajax_retraits.php', $.extend({}, {
          acces_h: false,
          id_adresse: this.currentAddress.address.id,
          filtre_retrait_cp: null,
          filtre_retrait_ville: null,
          type: 'relais_colis',
          _format: 'json'
        }, configuration)
        )
          .done(resolve)
          .fail(reject)
      })
    } else {
      return new Promise(resolve => {
        resolve([this.settings.forceOffer])
      })
    }
  }

  selectEndPoint (endPoint, $choice, marker) {
    this.resetSelection()
    $choice.addClass('selected')

    this.$suggestedList
      .find(`[data-type=${endPoint.type}]`)
      .addClass('selected')
      .data('endPoint', endPoint)

    this.$suggestedList
      .find(`[data-type=${endPoint.type}] .end-point-summary`)
      .html(endPoint.get('summary'))

    super.on('select', endPoint, $choice)

    this.$list.animate({ scrollTop: $choice.offset().top - this.$list.offset().top + this.$list.scrollTop() }, 1000)

    if (this.infoWindows.has(marker)) {
      this.infoWindows.get(marker).open(marker.map, marker)
    }
  }

  resetSelection () {
    if (this.$list) {
      this.$list.find(' > li.selected').removeClass('selected')
    }
    if (this.$suggestedList) {
      this.$suggestedList.find(' > li.selected').removeClass('selected')
    }
    for (let [marker, infoWindow] of this.infoWindows) {
      infoWindow.close()
    }
  }

  invalidate () {
    if (this.map) {
      this.googleMapsAPI.event.trigger(this.map, 'resize')
      this.fitMap()
    }
  }

  initManualSearch ($container) {
    let $searchBar = $('<div/>', { class: 'search-bar' }).prependTo($container)

    this.$manualSearchInput = $('<input/>', {
      class: 'endpoint-search',
      placeholder: 'Saisissez votre code postal'
    })
      .prependTo($searchBar)
      .wrap('<span/>')

    this.$manualSearchInput.prop('disabled', this.settings.forceOffer !== undefined)
    this.manualSearchDropList = new TownList(this.$manualSearchInput, {
      $wrapper: this.$manualSearchInput.parent().parent()
    })
      .addListener('select', (widget, town) => {
        this.searchAlternativeEndPoints(this.$manualSearchInput.val(), town)
      })
      .addListener('reset', () => {
        let loader = new Loader(this.$map)
        let loading_task_id = loader.startTask()
        this.clearMarkers()
        this.updateSubject()
        this.refreshMap({ type: this.senderMode.offers.map(offer => offer.type).join(',') })
          .then(data => {
            if (this.filterType !== null) {
              this.updateRelaysFilter(endPoint => endPoint.type === this.typeFilter)
            }
            loader.stopTask(loading_task_id)
          })
          .catch(data => loader.stopTask(loading_task_id))
      })

    if (this.typeFilter === null) {
      this.$freeRelaysFilter = $('<div/>', { class: 'filter ' + (!this.filterFreeRelays ? 'selected' : '') })
        .append('Afficher les livraisons express payantes')
        .append($('<span/>', { class: 'checkbox' }))
        .click(this.switchFreeRelaysFilter.bind(this))
        .appendTo($searchBar)
    }
  }

  switchFreeRelaysFilter () {
    this.$freeRelaysFilter.toggleClass('selected')
    this.filterFreeRelays = !this.$freeRelaysFilter.hasClass('selected')
    this.updateRelaysFilter(this.getFreeRelaysFilterVisibility.bind(this))
    this.fitMap()
  }

  getFreeRelaysFilterVisibility (endPoint, filterFreeRelays) {
    let filter = filterFreeRelays === undefined
      ? this.filterFreeRelays
      : filterFreeRelays
    return this.settings.forceOffer !== undefined || !filter || endPoint.cost.total == 0
  }

  updateRelaysFilter (predicate) {
    for (let marker of this.markers) {
      if (marker.endPoint != undefined) {
        marker.setVisible(predicate(marker.endPoint))
      }
    }

    if (this.$list) {
      this.$list.find('>li').each((i, e) => {
        if ($(e).data('endPoint') !== undefined) {
          if (predicate($(e).data('endPoint'))) {
            $(e).show()
          } else {
            $(e).hide()
          }
        }
      })
    }

    this.resetSelection()
    super.on('unselect')
  }

  searchAlternativeEndPoints (cp, town) {
    let loader = new Loader(this.$map)
    let loading_task_id = loader.startTask()
    this.clearMarkers()
    this.refreshMap({
      type: this.senderMode.offers.map(offer => offer.type).join(','),
      id_adresse: null,
      filtre_retrait_cp: cp,
      filtre_retrait_ville: town
    })
      .then(data => {
        this.updateSubject(cp + ' ' + town)
        if (this.typeFilter !== null) {
          this.updateRelaysFilter(endPoint => endPoint.type === this.typeFilter)
        }
        loader.stopTask(loading_task_id)
        super.on('unselect')
      })
      .catch(data => loader.stopTask(loading_task_id))
  }

  update (senderMode, options) {
    // console.log('update', senderMode, options)

    this.senderMode = senderMode

    let settings = $.extend({}, {
      loader: null
    }, options)

    if (settings.providers) {
      this.settings.providers = settings.providers
    }

    if (settings.loader) {
      this.settings.loader = settings.loader
    }

    if (settings.forceOffer) {
      this.settings.forceOffer = settings.forceOffer
    }

    this.settings.expectsFreeRelays = senderMode.offers.length > 0 &&
          senderMode.offers.filter(offer => offer.cost.total === 0).length > 0
    this.filterFreeRelays = this.filterFreeRelays && this.settings.expectsFreeRelays

    // if at least one suggestion, display a list like home modes
    // if (senderMode.offers.reduce((atLeastOne, offer) => atLeastOne || offer.suggestedEndPoint !== null, false)) {
    if (this.$suggestedList === null) {
      this.$suggestedList = $(`<table>
        <tbody>
          <tr>
            <td><ul class="relay-modes"/></td>
          </tr>
        </tbody>
      </table>`).appendTo(this.$container).find('ul')
    }

    this.resetUI()

    this.$suggestedList.html(senderMode.offers.map(offer => {
      let suggestedEndPoint = null
      if (this.settings.forceOffer) {
        suggestedEndPoint = new EndPoint(this.settings.forceOffer)
      } else if (offer.suggestedEndPoint) {
        offer.suggestedEndPoint.provider = this.settings.providers[offer.suggestedEndPoint.type]
        offer.suggestedEndPoint.cost = offer.cost.total
        suggestedEndPoint = new EndPoint(offer.suggestedEndPoint)
      }
      let $choice = $('<li/>', { 'data-type': offer.type }).html(`
          <div class="mode">
              <span class="checkbox"></span>
              <span class="name"><img src="${this.settings.ressources.images[offer.type] != undefined ? require('../../images/interface/default/livraison/' + this.settings.ressources.images[offer.type]) : ''}" alt="${offer.provider}"/></span>
              <span class="availability">Livraison ${offer.deliverDateLabel}</span>
              <span class="cost">${offer.cost.total ? StringUtils.toLocaleString(offer.cost.total, { style: 'currency', currency: 'EUR' }) : 'Livraison offerte'}</span>
          </div>
          <div class="address">
            ${suggestedEndPoint !== null
    ? `
                <div class="end-point-summary">
                  ${suggestedEndPoint.get('summary')}
                </div>
                <button class="button choose-end-point">Choisir une autre adresse</button>
              `
    : '<button class="button choose-end-point" style="margin: ">Choisissez un point de retrait</button>'}
          </div>
        `)

      const shipping = document.querySelector('.contenu.adresses')

      $choice.find('.mode').click(e => {
        // switch to map or select
        shipping.setAttribute('data-shipping', offer.type)

        if (shipping.classList.contains('shipping-selected')) {
          window.dispatchEvent(new Event('selectModifyShipping'))
        } else {
          window.dispatchEvent(new Event('selectShipping'))
          shipping.classList.add('shipping-selected')
        }
        if ($choice.data('endPoint')) {
          // this.addressChanged = false
          this.$suggestedList.find('.selected').removeClass('selected')
          $choice.addClass('selected')
          super.on('select', $choice.data('endPoint'), $choice)
        } else {
          // this.addressChanged = true
          this.switchUI(settings.loader, $choice.data('endPoint') || { type: offer.type }, true)
        }
      })

      $choice.data('endPoint', suggestedEndPoint)

      $choice.find('.button.choose-end-point').click(e => {
        // this.addressChanged = true
        shipping.setAttribute('data-shipping', offer.type)

        if (shipping.classList.contains('shipping-selected')) {
          window.dispatchEvent(new Event('selectModifyShipping'))
        } else {
          window.dispatchEvent(new Event('selectShipping'))
          shipping.classList.add('shipping-selected')
        }
        this.switchUI(settings.loader, $choice.data('endPoint') || { type: offer.type }, true)
      })

      return $choice
    }))

    if (this.googleMapsAPI) {
      this.clearMarkers()
      this.updateSubject(this.settings.forceOffer ? this.settings.forceOffer.position : undefined)
      this.refreshMap({ type: this.senderMode.offers.map(offer => offer.type).join(',') })
    }
  }

  resetUI () {
    if (!this.$suggestedList.is(':visible')) {
      this.$suggestedList.show()
    }
    if (this.$mapContainer !== null) {
      this.$mapContainer.hide()
    }
    if (this.$switchUILink) {
      this.$switchUILink.hide()
    }
  }

  switchUI (loader, endPoint, forceMapDisplay) {
    if (this.$suggestedList.is(':visible')) {
      this.$suggestedList.hide()
      this.typeFilter = endPoint.type

      let joinArray = ['relais_colis', 'mondial_relay']
      if (joinArray.indexOf(this.typeFilter) < 0) {
        joinArray = [this.typeFilter]
      }
      if (this.$mapContainer !== null) {
        let loading_task_id = loader.startTask()

        this.clearMarkers()
        this.updateSubject()

        if (this.$manualSearchInput.val() !== '') {
          this.$manualSearchInput.val('')
        }

        this.$mapContainer.show()
        this.invalidate()
        this.refreshMap({ type: this.senderMode.offers.map(offer => offer.type).join(',') })
          .then(data => {
            if (this.filterType !== null) {
              this.updateRelaysFilter(endPoint => joinArray.indexOf(endPoint.type) > -1)
            }
            if (endPoint) {
              let $choice = this.getEndPointChoice(endPoint)
              if (!$choice) {
                $choice = this.buildEndPoint(endPoint)
              }
              $choice.click()
            }
            loader.stopTask(loading_task_id)
          })
          .catch(data => loader.stopTask(loading_task_id))

        // this.updateRelaysFilter(endPoint => this.typeFilter === endPoint.type)
      } else {
        this.buildRelayPicker(loader)
          .then(() => {
            // If suggestion not in list, add it then select it
            if (endPoint) {
              let $choice = this.getEndPointChoice(endPoint)
              if (!$choice) {
                $choice = this.buildEndPoint(endPoint)
              }
              $choice.click()
            }

            this.updateRelaysFilter(endPoint => joinArray.indexOf(endPoint.type) > -1)
          })
      }
      if (this.$switchUILink === null) {
        this.$switchUILink = $('<p/>', { class: 'go-back-to-list' })
          .prependTo(this.$container)
          .html('&lt; Revenir à la liste des modes en point relais')
          .click(e => this.switchUI())
      } else {
        this.$switchUILink.show()
      }
    } else {
      if (forceMapDisplay) {
        return
      }
      this.$suggestedList.show()
      this.$mapContainer.hide()
      if (this.$switchUILink) {
        this.$switchUILink.hide()
      }
    }
  }

  // Builds UI map, list, search stuffs
  buildRelayPicker (loadIndicator) {
    let loading_task_id = loadIndicator.startTask()

    // We need a map and a list of end points to pick
    if (!this.googleMapsAPI) {
      return this.createMap()
        .then(map => {
          this.clearMarkers()
          this.updateSubject(this.settings.forceOffer ? this.settings.forceOffer.position : undefined)
          return this.refreshMap({ type: this.senderMode.offers.map(offer => offer.type).join(',') })
            .then(data => loadIndicator.stopTask(loading_task_id))
            .catch(data => loadIndicator.stopTask(loading_task_id))
        })
        .catch(error => console.log('Map creation', error))
    } else {
      this.clearMarkers()
      this.updateSubject(this.settings.forceOffer ? this.settings.forceOffer.position : undefined)
      return this.refreshMap({ type: this.senderMode.offers.map(offer => offer.type).join(',') })
        .then(data => loadIndicator.stopTask(loading_task_id))
        .catch(data => loadIndicator.stopTask(loading_task_id))
    }
  }

  getVisibleMarkers (options) {
    let settings = $.extend({}, {
      endPointsOnly: false,
      filterFreeRelays: undefined
    }, options)

    return this.markers.filter(marker =>
      (!settings.endPointsOnly && marker.endPoint == undefined) ||
          marker.endPoint != undefined &&
          (this.typeFilter === null
            ? this.getFreeRelaysFilterVisibility(marker.endPoint, settings.filterFreeRelays)
            : marker.endPoint.type === this.typeFilter))
  }

  fitMap () {
    if (this.getVisibleMarkers().length < 2) {
      this.map.setZoom(this.settings.defaultZoom)
      if (this.subjectMarker !== null) {
        this.map.setCenter(this.subjectMarker.getPosition())
      }
    } else {
      let bounds = new this.googleMapsAPI.LatLngBounds()

      for (let marker of this.getVisibleMarkers().slice(0, 4)) {
        bounds.extend(marker.getPosition())
      }
      this.map.fitBounds(bounds)
    }
  }

  switchMapView () {
    this.$map.toggleClass('show')

    this.$list.toggleClass('hidden')
    this.$mapSwitcher.html(this.$map.hasClass('show')
      ? this.mapSwitcherLabels.showList
      : this.mapSwitcherLabels.showMap)

    if (this.$map.hasClass('show')) {
      this.invalidate()
    }
  }

  refreshMap (configuration) {
    this.messageBoxManager.clearNotifications()
    return new Promise((resolve, reject) => {
      this.retrieveEndPoints(configuration)
        .then(endPointsData => {
          let $leftColumn = this.$mapContainer.find('> .left-column')
          if ($leftColumn.length == 0) {
            // insert a link to relais colis
            $leftColumn = $('<div/>', { class: 'left-column' }).prependTo(this.$mapContainer)
          }

          // Build end points list UI if needed and reset it
          if (this.$list === undefined) {
            this.$list = $('<ul/>', { class: 'end-point-picker' }).prependTo($leftColumn)
          }

          this.$list.empty()

          if (this.$mapSwitcher === undefined) {
            this.$mapSwitcher = $('<a/>', { class: 'map-switcher' })
              .html(this.mapSwitcherLabels.showMap)
              .appendTo(this.$mapContainer)
              .click(this.switchMapView.bind(this))
              .wrap($('<p/>', { class: 'actions-bar' }))
          }

          // Build manual search UI if needed
          if (this.$manualSearchInput === undefined) {
            this.initManualSearch($leftColumn)
          }

          if (this.$freeRelaysFilter) {
            this.$freeRelaysFilter.toggle(this.settings.expectsFreeRelays === true && this.settings.forceOffer === undefined)
          }

          // We have to let first free relais at first
          let endPoints = endPointsData.map(endPointData => {
            // end point type should reasonably be in those requested...
            endPointData.provider = this.settings.providers[endPointData.type]
            const offer = this.senderMode.offers.filter(offer => offer.type === endPointData.type)
            if (offer.length) {
              endPointData.cost = offer[0].cost.total
            }
            return new EndPoint(endPointData)
          })

          let firstRelayIndex = endPoints.findIndex(endPoint => endPoint.type == 'relais_colis')

          if (firstRelayIndex != -1) {
            let firstRelay = endPoints[firstRelayIndex]
            endPoints.splice(firstRelayIndex, 1)
            endPoints.unshift(firstRelay)
          }

          for (let endPoint of endPoints) {
            this.buildEndPoint(endPoint)
          }

          if (this.settings.expectsFreeRelays &&
                    this.settings.forceOffer === undefined &&
                    this.getVisibleMarkers({ endPointsOnly: true, filterFreeRelays: true }).length === 0) {
            // Display a message
            this.messageBoxManager.notify(
              'Malgré tous nos efforts, nous n\'avons aucun point de retrait gratuit pour cette adresse.',
              { type: 'info', selector: 'no-relay-found' }
            )
          }

          if (this.getVisibleMarkers({ endPointsOnly: true }).length == 0 &&
                    this.typeFilter === null &&
                    this.settings.expectsFreeRelays &&
                    this.filterFreeRelays) {
            this.switchFreeRelaysFilter()
          } else if (this.getVisibleMarkers({ endPointsOnly: true }).length === 1) {
            this.googleMapsAPI.event.trigger(this.getVisibleMarkers({ endPointsOnly: true })[0], 'click')
          } else {
            this.fitMap()
          }

          if (this.typeFilter === null && this.getVisibleMarkers({ endPointsOnly: true, filterFreeRelays: true }).length === this.getVisibleMarkers({ endPointsOnly: true, filterFreeRelays: false }).length) {
            // Since there is no payable end point, hide the filter box
            this.$freeRelaysFilter.toggle(false)
          }
          resolve(endPointsData)
        }).catch(reject)
    })
  }

  getEndPointChoice (endPoint) {
    return this.$list
      ? this.$list
        .children()
        .filter((i, choice) =>
          $(choice).data('endPoint').type === endPoint.type &&
              $(choice).data('endPoint').id_retrait === endPoint.id_retrait)
        .first()
      : null
  }

  buildEndPoint (endPoint) {
    let marker = this.addMarker({
      position: endPoint.get('position'),
      title: endPoint.get('libelle'),
      content: endPoint.get('formattedDescription') + '<p class="selected"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Sélectionné</p>',
      icon: this.icons[endPoint.get('type')],
      endPoint: endPoint,
      visible: this.typeFilter === null
        ? this.getFreeRelaysFilterVisibility(endPoint)
        : endPoint.type === this.typeFilter
    })

    let $choice = $('<li/>').data('endPoint', endPoint).appendTo(this.$list)
    $choice.html(endPoint.get('formattedDescription'))
    $choice.prepend($('<span/>', { class: 'checkbox' }))

    if (this.typeFilter === null
      ? this.getFreeRelaysFilterVisibility(endPoint)
      : endPoint.type === this.typeFilter) {
      $choice.show()
    } else {
      $choice.hide()
    }

    let selectEndPointHandler = event => {
      this.map.setCenter(marker.getPosition())
      this.selectEndPoint(endPoint, $choice, marker)

      /* if(!this.addressChanged) {
          this.switchUI();
         }
      this.addressChanged = false */
    }
    $choice.click(selectEndPointHandler)
    marker.addListener('click', selectEndPointHandler)

    return $choice
  }
}
